module.exports = __webpack_public_path__ + "img/ubi.70e92c4f.svg";